import { ADD_FILTER_ENT_ERI } from 'types/actions';

export const FilterIndexAdd = element => ({
    type: ADD_FILTER_ENT_ERI,
    element
});
  